import { useTranslation } from 'react-i18next';

import ConfirmDeletionModal from '../../../components/Modal/ConfirmDeletionModal';
import { useDeleteDomain } from './domainRegistration.mutations';
import { DomainBody } from '../../../api/generated/pap';

interface Props {
  domain: DomainBody;
  identityProviderUrl: string;
  open: boolean;
  onClose: (shouldUpdate: boolean) => void;
}

function DeleteDomainModal({ domain, identityProviderUrl, open, onClose }: Props) {
  const { t } = useTranslation('settings');
  const { mutateAsync: deleteDomain } = useDeleteDomain();

  const handleDelete = async () => {
    // TODO: Add error handling
    await deleteDomain(domain.id);
    onClose(true);
  };

  return (
    <ConfirmDeletionModal
      title={t('domainRegistration.confirmDomainDeletion')}
      description={t('domainRegistration.domainDeletionDescription')}
      text={domain.name}
      subText={identityProviderUrl}
      primaryButtonText={t('domainRegistration.deleteDomain')}
      iconName="language"
      open={open}
      onSubmit={handleDelete}
      onClose={onClose}
    />
  );
}

export default DeleteDomainModal;
